import React from 'react';

import { useTranslation } from 'react-i18next';
import { Flex, H4, P } from 'design-system-web';

import { VisitorConfiguration } from '../../../../types/VisitorConfiguration';

import tabStyles from './styles.scss';

type VisitorManagementCustomFieldsTabProps = {
  channel: any;
  onConfigUpdated: (update: VisitorConfiguration) => void;
  config: VisitorConfiguration;
  loading?: boolean;
  showValidationErrors?: boolean;
};

/**
 * Visitor configuration tab for custom fields (list/detail flows wire in follow-up work).
 * Tab visibility is gated by {@link FeatureFlag.VisitorManagementCustomFields} on the parent page.
 */
export function VisitorManagementCustomFieldsTab({
  channel: _channel,
  onConfigUpdated: _onConfigUpdated,
  config: _config,
  loading: _loading,
  showValidationErrors: _showValidationErrors,
}: VisitorManagementCustomFieldsTabProps): React.ReactElement {
  const { t } = useTranslation();

  return (
    <Flex direction="column" gap={5} className={tabStyles.container}>
      <Flex direction="column" gap={1}>
        <H4>{t('web.admin.visitorManagement.configuration.tab.customFields')}</H4>
        <P className={tabStyles.description}>
          {t('web.admin.visitorManagement.configuration.tab.customFields.description')}
        </P>
      </Flex>
    </Flex>
  );
}
